<template>
  <div class="text-xs-center">
    <v-dialog persistent v-model="showThis" max-width="500">
      <v-card dark :color="color">
        <v-toolbar>
          <v-icon :color="color">{{errorIcon}}</v-icon>
          <v-toolbar-title>
            {{title}}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          {{text}}
        </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="refresh" flat @click.stop="reloadPage">
              refresh
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn flat icon @click.stop="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import EventBus from '@/EventBus';

export default {
  data() {
    return {
      showThis: false,
      title: '',
      text: '',
      type: 'info',
      refresh: false,
    };
  },
  created() {
    EventBus.$on('reader-dialog', this.listener);
  },
  beforeDestroy() {
    EventBus.$off('reader-dialog', this.listener);
  },
  methods: {
    listener(data) {
      this.type = data.type;
      this.title = data.title;
      this.text = data.text;
      this.refresh = data.refresh;
      this.showThis = !data.hide;
    },
    close() {
      this.showThis = false;
    },
    reloadPage() {
      this.$router.go({
        path: this.$router.path,
        query: {
          t: + new Date()
        }
      });
    },
  },
  computed: {
    errorIcon() {
      if (this.type === 'error') {
        return 'error';
      } else if (this.type === 'warning') {
        return 'warning';
      }
      return 'info';
    },
    color() {
      if (this.type === 'error') {
        return 'red';
      } else if (this.type === 'warning') {
        return 'yellow darken-3';
      }
      return '';
    },
  },
};
</script>
